import React, { useEffect } from "react";

import GreyTable from '../../../../components/Tables/GreyTable';
import { DlvDetail, resetDlvDetail } from '../../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BillingDetail = ({ selectedProduction, selectedAccount }) => {

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const dispatch = useDispatch();

  const { DlvDetailData } = useSelector((state) => state.PartyProfileSlice);

  useEffect(() => {
    dispatch(resetDlvDetail())
    dispatch(DlvDetail({
      selectedIds: selectedProduction ? selectedProduction.toString() : "",
      PARTYWISEIds: selectedAccount ? selectedAccount.toString() : ""
    }));
  }, [selectedProduction, selectedAccount]);

  const columns = [
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "date", label: "Date", align: "center ", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Days", label: "Days", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Process", label: "Process", align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "LotNo", label: "Lot. No.", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Meter", label: "Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Taka", label: "Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Tp", label: "TP", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Rate", label: "Rate", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "GrossAmount", label: "Gross Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "TaxableAmount", label: "Taxable Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "SGST", label: "SGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "CGST", label: "CGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "NetAmount", label: "Net Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const row = DlvDetailData?.DlvDate?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;
    return {
      id: index,
      srNumber: (index + 1).toString().padStart(totalLength, "0"),
      ...row,
      date: new Date(row.date).toLocaleDateString("en-GB"),
      Days: row.Days,
      ChallanNo: row.ChallanNo,
      LotNo: row.LotNo,
      Meter: row.Meter,
      Taka: row.Taka,
      Tp: row.Tp,
      Rate: row.Rate,
      GrossAmount: row.GrossAmount,
      TaxableAmount: row.TaxableAmount,
      SGST: row.SGST,
      CGST: row.CGST,
      NetAmount: row.NetAmount,
    };
  })
  if (DlvDetailData === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <div>
      <Row>
        <Col>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                color:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour8,
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight:"700" }}>
              BILLING DETAIL
            </h2>
          </div>
          <div><GreyTable columns={columns} data={row} iscolourDark={iscolourDark}
            iscolour={iscolour} /></div>
        </div>
      </Col>
    </Row>
    </div >
  )
}
